// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"882b5637","498":"460bff2a","598":"b8b8abda","703":"67f6f7e7","787":"7922278b"}[chunkId] + ".chunk.js";
};